const demoAccounts = {
  'r@gmail.com': {
    password: 'Rs@123456',
    userType: 'employer',
    dashboardPath: '/dashboard/employer',
    label: 'Employer Demo Account'
  },
  'agent@example.com': {
    password: 'Agent@123',
    userType: 'agent',
    dashboardPath: '/agent/dashboard',
    label: 'Agent Demo Account'
  },
  'test@franchise.com': {
    password: 'franchise123',
    userType: 'franchise',
    dashboardPath: '/franchise/dashboard',
    label: 'Franchise Demo Account'
  }
};

export const getDemoAccountByEmail = (email) => {
  if (!email) return null;
  return demoAccounts[email.trim().toLowerCase()] || null;
};

export const getDemoAccountUserType = (email) => {
  const account = getDemoAccountByEmail(email);
  return account?.userType || null;
};

export const getDemoAccountDashboardPath = (email) => {
  const account = getDemoAccountByEmail(email);
  return account?.dashboardPath || null;
};

export const getDemoCredentialsList = () =>
  Object.entries(demoAccounts).map(([email, account]) => ({
    email,
    password: account.password,
    label: account.label
  }));
